// sku -> Produto da api crm
export const crmProdutoExpress = {
    1: "ECPF_A1",
    2: "ECNPJ_A1",
    65: "ECPF_A3_NUVEM",
    24: "ECPF_A3_1",
    21: "ECPF_A3_2",
    9: "ECPF_A3_3",
    27: "ECNPJ_A3_1",
    19: "ECNPJ_A3_2",
    3: "ECNPJ_A3_3",
}

export const ObterProdutoExpress = (sku) => {
    return crmProdutoExpress[sku] || null;
}